export const setTimeRange = (startTime, endTime) => ({
  type: 'SET_TIME_RANGE',
  startTime,
  endTime
});
